import ReactGA from "react-ga4";

export enum Permissions {
  ROLE_CCP = "role:CCP",
  ROLE_WANDACONCIERGE = "role:WandaConcierge",
  ROLE_Member = "role:Member",
  ROLE_ORGANIZATION = "role:Organization",
  ROLE_PERSON = "role:Person",
  ROLE_TP = "role:TransportationProvider",
  ROLE_DRIVER = "role:Driver",
  ROLE_PAYEE = "role:Payee",
  ROLE_FM = "role:FleetManager",
  ROLE_CU = "role:CredentialingUser",
  ROLE_CM = "role:CredentialingManager",
  API_PO_ORGANIZATION = "api.personorg.organization",
  API_PO_PERSON = "api.personorg.person",
  API_UM_PERSON = "api.usermanagement.person",
  API_REVEAL_PERSON = "api.reveal.provider",
  API_PO_ADMIN = "api.personorg.admin",
  API_UM_PROVIDER = "api.usermanagement.provider",
  API_PROVIDER = "api.provider",
}

export enum RegistrationComponentLoad {
  ZipCode = "ZipCode",
  Email = "Email",
  IDPNotExists = "IDPNotExists",
  PersonMatch = "PersonMatch",
  Message = "Message",
  SingleWandaEmailValidation = "SingleWandaEmailValidation",
  ResetPassword = "ResetPassword",
}

export enum RegistrationEnums {
  IDPDoesnotExists = 1,
  PersonMatch = 2,
  SourceSystemID = 2,
  KeyTypeId = 18,
  PersonTypeId = 34,
  OrganizationId = 864708,
  RelationshipRefId = 1,
  PersonRelationshipRefId = 12,
  DateOfBirth = "1900-01-01",
  Role = "CCP",
  clientId = "MTM-ui-ccp-client",
  WandaEmail = 19,
  WandaSubscriptionPlan = 23,
  CustomerKeyTypeId = 11,
  PersonToBenefitRel = 9,
}

export enum PersonAttributesKey {
  WandaAccommodations = 22,
}

export enum ServicesTypesComponentLoad {
  Welcome = "Welcome",
  SomeoneElse = "SomeoneElse",
  IWillBeUsingServices = "IWillBeUsingServices",
  MTMBenefitCheck = "MTMBenefitCheck",
  AddAnotherServiceUser = "AddAnotherServiceUser",
  MyselfWillUseServices = "MyselfWillUseServices",
  SomeoneElseWillUseServices = "SomeoneElseWillUseServices",
  TrustedContacts = "TrustedContacts",
  DashBoard = "DashBoard",
  ManageServiceUser = "ManageServiceUser",
  ManageServiceUserMobile = "ManageServiceUserMobile",
  WandaPlusSubscription = "WandaPlusSubscription",
}

export enum GeneralDefinition {
  Myself = "Myself",
  SomeoneElse = "SomeoneElse",
  DefaultPersonId = 0,
  MobileView = 992,
  EmptyString = "",
  DefaultOrganizationId = 1,
  Position = 2,
  EditProfile = "EditProfile",
  WelcomePage = "/DashBoard/AddServiceUser/Welcome",
  ProfilePage = "Profile",
  AddMaxServiceUser = "/Welcome",
}

export type AddressSuggestion = {
  description: string;
  place_id: string;
};

export enum InsertParameter {
  passwordGenerated = 2,
  MatchBenefit = 3,
  updateRecord = 4,
  ViewBenefit = 5,
  CCPIntake = 6,
  InsertRecord = 7,
  InsertRecordForMTMUser = 8,
}

export enum SearchPattern {
  RegistrationComplete = 1,
  PersonFound = 2,
  UploadImageId = 3,
  CheckAvailability = 4,
}

export interface ServiceUserData {
  serviceUserPersonId: number;
  registeredEmail: string;
  serviceUserFirstName: string;
  routingPage: string;
  CCPDetailsId: number;
  serviceUsersStatus: boolean;
}

export enum Environment {
  Development = "Development",
  QA = "QA",
  Staging = "Staging",
  UAT = "UAT",
  Production = "Production",
}

export type LocationAddressType = {
  address1: string;
  address2?: string | null;
  city: string;
  state: string;
  zip: string;
  county: string;
};

export interface LookupItem {
  id: number;
  itemId: string;
  itemName: string;
  name: string;
}

export interface SelectOption {
  id: string | number;
  display: string;
}

export enum PersonTypeIds {
  member = 2,
  wandaUser = 34,
}

export type PersonByPersonType = {
  personAttributes: PersonAttributesType;
};

export type PersonAttributesType = {
  homeAddress: AddressType;
  mailingAddress: AddressType;
  homeFullAddress?: "";
  mailingFullAddress?: "";
};

export type AddPersonAddressType = {
  homeAddress: AddressType;
  mailingAddress: AddressType;
};

export type AddressType = {
  address1: string;
  address2: string;
  city: string;
  state: string;
  zip: string;
  county: string;
  hasSameAddress?: boolean | undefined;
  homeFullAddress?: string;
  mailingFullAddress?: string;
};

export interface AddressValueType {
  long_name: string;
  short_name: string;
  types: string[];
}

export type PersonAddresses = {
  homeAddress: PersonAddress;
  mailingAddress: PersonAddress;
};

export type PersonAddress = {
  address1: string;
  address2: string;
  city: string;
  state: string;
  zip: string;
  hasSameAddress?: boolean;
};

export function getEmptyPersonByPerson() {
  return {
    personAttributes: {
      homeAddress: {
        address1: "",
        address2: "",
        city: "",
        state: "",
        zip: "",
        county: "",
        hasSameAddress: true,
        homeFullAddress: "",
      },
      mailingAddress: {
        address1: "",
        address2: "",
        city: "",
        state: "",
        zip: "",
        county: "",
        hasSameAddress: true,
        mailingFullAddress: "",
      },
    },
  };
}

export interface IZipData {
  city: string;
  state: string;
  zipcode: number;
}

export function DefaultZipData() {
  return {
    city: "",
    state: "",
    zipcode: 0,
  };
}

export type CareEditInfo = {
  personId: number;
  firstName: string;
  lastName: string;
  phoneNumber: string;
  primaryPhoneAttribute: IPrimaryPhoneAttribute;
  emailId: string;
  wandaEmailAddressAttribute: IWandaEmailAddressAttribute;
  relationship: string;
  dateOfBirth: string;
  wandaEmail: string;
  Text: string;
  userText: string;
  check: boolean;
};

export interface IWandaEmailAddressAttribute {
  noEmailAddress: boolean;
  notificationOn: boolean;
  communicationTypes: {
    informative: boolean;
    promotional: boolean;
  };
}

export interface IPrimaryPhoneAttribute {
  canReceiveVoiceCalls: boolean;
  canReceiveTexts: boolean;
  noPhoneNumber: boolean;
  notificationOn: boolean;
  communicationTypes: {
    informative: boolean;
    promotional: boolean;
  };
}

export function DefaultCareEditInfo() {
  return {
    personId: 0,
    firstName: "",
    lastName: "",
    phoneNumber: "",
    primaryPhoneAttribute: {
      canReceiveVoiceCalls: false,
      canReceiveTexts: true,
      noPhoneNumber: false,
      notificationOn: true,
      communicationTypes: {
        informative: true,
        promotional: false,
      },
    },
    emailId: "",
    wandaEmailAddressAttribute: {
      noEmailAddress: false,
      notificationOn: true,
      communicationTypes: {
        informative: true,
        promotional: true,
      },
    },
    relationship: "",
    dateOfBirth: "",
    wandaEmail: "",
    careGiverId: 0,
    Text: "",
    userText: "",
    check: true,
  };
}

export enum Mode {
  MileageReimbursement = 1,
  PublicTransit = 2,
  Cab = 3,
  Paralift = 4,
  Stretcher = 5,
  Ambulance = 6,
  Restricted_SecuredTransport = 7,
  ADAServices = 8,
}

export enum TripReasonEnum {
  Wanda = 151,
}

export enum WandaTripStatus {
  Booked = 1,
  Cancelled = 2,
  Completed = 3,
}
export enum RevealTripStatus {
  Valid = 1,
  NoShowByMember = 7,
  NoShowbyTransportationProvider = 8,
  MemberCancel = 10,
  TurnBack = 11,
}

export enum WandaServices {
  upcomingServices = "upcomingServices",
  pastServices = "pastServices",
  favoriteServices = "favoriteServices",
}
export enum WandaBookingStatus {
  Booked = "Booked",
  Canceled = "Canceled",
  Completed = "Completed",
}

export interface IPersonIDPData {
  emailAddress: string;
  firstName: string;
  lastName: string;
  phoneNumber: string;
  promotionalCheck: boolean;
}

export function DefaultPersonIDPData() {
  return {
    emailAddress: "",
    firstName: "",
    lastName: "",
    phoneNumber: "",
    promotionalCheck: true,
  };
}

export function TrackAnalytics(
  category: string,
  action: string,
  label: string
) {
  ReactGA.event({
    category: category,
    action: action,
    label: label,
  });
}

export enum InputBoxLength {
  DriverInstructionText = 255,
}

export enum SchedulingServicesFor {
  Myself = "Myself",
  SomeoneElse = "SomeoneElse",
}

export enum RegistrationStatusDefaultValues {
  DefaultPersonId = 0,
  EmptyString = "",
}

export enum AddressKeyType {
  HomeAddress = 14,
  MailingAddress = 15,
}

export enum TripAddressDetails {
  DriverInstructions = "driverInstruction",
}

export interface PersonSummary {
  personId: number;
  firstName: string;
  whoWillUseServices: string;
}
export interface ZipCodeAddress {
  city: string;
  state: string;
}

export const defaultZipCodeAddress = {
  city: "",
  state: "",
};

export enum userType {
  Caregiver = "Caregiver",
}
